import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Me from '../views/Me'


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    meta: { isUserLogin: true },
    redirect : "/Index"
  },
  {
    path: '/Index',
    name: 'Index',
    meta: { isUserLogin: true },
    component: Index
  },
  {
    path: '/Me',
    name: 'Me',
    meta: { isUserLogin: true },
    component: Me
  },
  {
    path: '/ProList',
    name: 'ProList',
    meta: { isUserLogin: true },
    component: () => import('../views/ProList.vue')
  },
  {
    path: '/Contact',
    name: 'Contact',
    meta: { isUserLogin: true },
    component: () => import('../views/ProList.vue')
  },
  {
    path: '/Details',
    name: 'Details',
    meta: { isUserLogin: true },
    component: () => import('../views/Details.vue')
  },
  {
    path: '/UserInfo',
    name: 'UserInfo',
    meta: { isUserLogin: true },
    component: () => import('../views/user/UserInfo.vue')
  },
  {
    path: '/Withdrawal',
    name: 'Withdrawal',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Withdrawal.vue')
  },
  {
    path: '/Recharge',
    name: 'Recharge',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Recharge.vue')
  },
  {
    path: '/Share',
    name: 'Share',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Share.vue')
  },
  {
    path: '/Proxycen',
    name: 'Proxycen',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Proxycen.vue')
  },
  {
    path: '/App_down',
    name: 'App_down',
    meta: { isUserLogin: true },
    component: () => import('../views/user/App_down.vue')
  },
  {
    path: '/Financial',
    name: 'Financial',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Financial.vue')
  },
  {
    path: '/My_investment',
    name: 'My_investment',
    meta: { isUserLogin: true },
    component: () => import('../views/user/My_investment.vue')
  },
  {
    path: '/Message',
    name: 'Message',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Message.vue')
  },
  {
    path: '/Reg',
    name: 'Reg',
    component: () => import('../views/Reg.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/Forget',
    name: 'Forget',
    component: () => import('../views/Forget.vue'),
  },
  {
    path: '/Information',
    name: 'Information',
    meta: { isUserLogin: true },
    component: () => import('../views/Information.vue')
  },
  {
    path: '/Recommend',
    name: 'Recommend',
    meta: { isUserLogin: true },
    component: () => import('../views/Recommend.vue')
  },
  {
    path: '/Detail',
    name: 'Detail',
    meta: { isUserLogin: true },
    component: () => import('../views/user/Detail.vue')
  }
];

const router = new VueRouter({
 // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  //每次跳转到新页面都回到页面的顶部
  scrollBehavior(to,from,savedPosition){
    return { x:0, y:0}
  }
});

export default router
